import { Button, Card, CardContent, FormHelperText, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useState } from "react";
import { addGoogleAccount, getGoogleAccounts, getGoogleAccountTypes } from "../../Services/API/GoogleAccount";
import DropdownComponent from "../Dropdown/DropdownComponent";
import LoadingBar from "../LoadingBar/LoadingBar";
import { StyledTextField } from "../TextField/TextField";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
  },
  error: {
    color: theme.palette.error.main,
  },
  textField: {
    "& .Mui-error": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));

export default function GoogleAccountModal({
  openModal,
  setData,
  setShowSignifier,
  setShowError,
  dropdownObjects,
}) {
  const classes = useStyles();

  const [showInputError, setShowInputError] = useState(false);
  const [keyName, setKeyName] = useState("");
  const [accountKey, setAccountKey] = useState("");
  const [reCaptchaKey, setReCaptchaKey] = useState("");
  const [addProcessing, setAddProcessing] = useState(false);
  const googleTypeId = dropdownObjects[0].id;
  const [googleType, setGoogleType] = useState("");

  const data = {
    GoogleTypeId: googleTypeId === "" ? null : googleType.id,
    Name: keyName,
    Key: accountKey,
    Pkey: reCaptchaKey,
  };

  const checkAllEntered = () => {
    if (keyName === "" || accountKey === "") {
      return false;
    }
    return true;
  };

  const compare = (a, b) => {
    if (a < b) {
      return -1;
    }
    if (a > b) {
      return 1;
    }
    return 0;
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addGoogleAccount(data).then(() => {
        getGoogleAccountTypes().then((types) => {
          getGoogleAccounts().then((res) => {
            setShowSignifier(true);
            if (res) {
              res.sort((a, b) => {
                const order = compare(a.name, b.name);
                if (order !== 0) return order;
                return a[1] - b[1];
              });
              for (const i in res) {
                res[i].NumberofConfigurations =
                  res[i].clientGoogleConfigurationPlacesKeys.length +
                  res[i].clientGoogleConfigurationRecaptchaKeys.length;
                res[i].allTypes = types;
                for (const x in types) {
                  if (types[x].id === res[i].googleTypeId) {
                    res[i].type = types[x].name;
                  }
                }
              }
              setData(res);
              openModal(false);
            } else {
              setShowError(true);
            }
          });
          setAddProcessing(false);
        });
      });
    } else {
      setShowInputError(true);
    }
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add Google Account</p>
              </Grid>
              <Grid xs={12} sm={12} item>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Key Name"
                  label="KeyName"
                  variant="standard"
                  fullWidth
                  required
                  value={keyName}
                  error={showInputError && keyName === ""}
                  className={classes.textField}
                  onChange={(e) => setKeyName(e.target.value)}
                />
                {showInputError && keyName === "" && (
                  <FormHelperText className={classes.error}>Key Name Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownComponent
                  currValue={googleType}
                  items={dropdownObjects}
                  property="name"
                  title="Account Type"
                  handleChange={(value) => setGoogleType(value)}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Account Key"
                  label="Account Key"
                  value={accountKey}
                  error={showInputError && accountKey === ""}
                  className={classes.textField}
                  onChange={(e) => setAccountKey(e.target.value)}
                  variant="standard"
                  fullWidth
                  required
                />
                {showInputError && accountKey === "" && (
                  <FormHelperText className={classes.error}>Account Key Required</FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={12}>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="reCaptcha Private Key"
                  label="reCaptcha Private Key"
                  value={reCaptchaKey}
                  onChange={(e) => setReCaptchaKey(e.target.value)}
                  variant="standard"
                  fullWidth
                />
              </Grid>
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ color: "#82B288", marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
